import { AppBar, Grid } from '@mui/material'
import React from 'react'

import Logo from '../atoms/Logo'
import MobileMenu from '../molecules/MobileMenu'
import NavigationBar from '../molecules/NavigationBar'

const Header = () => {
	return (
		<AppBar
			position="static"
			sx={(theme) => ({
				backgroundColor: 'text.secondary',
				p: theme.spacing(2.5, 4, 0),
				pb: 2,
			})}
		>
			<Grid container>
				<Grid item xs={3} md={12} lg={2}>
					<Logo fill="white" />
				</Grid>
				<Grid
					item
					xs={9}
					md={12}
					lg={10}
					sx={(theme) => ({
						[theme.breakpoints.down('md')]: {
							'& .burger': {
								textAlign: 'right',
							},
							'& .MuiToolbar-root': {
								display: 'none',
							},
							justifyContent: 'flex-end',
						},
						[theme.breakpoints.up('md')]: {
							'& .burger': {
								display: 'none',
							},
						},
					})}
				>
					<NavigationBar white />
					<MobileMenu white={true} />
				</Grid>
			</Grid>
		</AppBar>
	)
}

export default Header
